import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class SharedService {
  private nbrOpenOrdersSource = new BehaviorSubject(0);
  currentNbrOpenOrders = this.nbrOpenOrdersSource.asObservable();

  private nbrExceptionOrdersSource = new BehaviorSubject(0);
  currentNbrExceptionOrders = this.nbrExceptionOrdersSource.asObservable();

  private nbrPendingOrdersSource = new BehaviorSubject(0);
  currentNbrPendingOrders = this.nbrPendingOrdersSource.asObservable();

  private nbrProcessingOrdersSource = new BehaviorSubject(0);
  currentNbrProcessingOrders = this.nbrProcessingOrdersSource.asObservable();

  private nbrDeletedOrdersSource = new BehaviorSubject(0);
  currentNbrDeletedOrders = this.nbrDeletedOrdersSource.asObservable();

  private nbrShippedOrdersSource = new BehaviorSubject(0);
  currentNbrShippedOrders = this.nbrShippedOrdersSource.asObservable();

  private nbrAbnormalOrdersSource = new BehaviorSubject(0);
  currentNbrAbnormalOrders = this.nbrAbnormalOrdersSource.asObservable();

  private nbrFrozenOrdersSource = new BehaviorSubject(0);
  currentNbrFrozenOrders = this.nbrFrozenOrdersSource.asObservable();

  private nbrFilteredOrdersSource = new BehaviorSubject(0);
  currentNbrFilteredOrders = this.nbrFilteredOrdersSource.asObservable();

  //ASN
  private nbrOpenAsnsSource = new BehaviorSubject(0);
  currentNbrOpenAsns = this.nbrOpenAsnsSource.asObservable();

  private nbrExceptionAsnsSource = new BehaviorSubject(0);
  currentNbrExceptionAsns = this.nbrExceptionAsnsSource.asObservable();

  private nbrCanceledAsnsSource = new BehaviorSubject(0);
  currentNbrCanceledAsns = this.nbrCanceledAsnsSource.asObservable();

  private nbrPendingAsnsSource = new BehaviorSubject(0);
  currentNbrPendingAsns = this.nbrPendingAsnsSource.asObservable();

  private nbrProcessingAsnsSource = new BehaviorSubject(0);
  currentNbrProcessingAsns = this.nbrProcessingAsnsSource.asObservable();

  //prod
  private nbrAllProductsSource = new BehaviorSubject(0);
  currentNbrAllProducts = this.nbrAllProductsSource.asObservable();

  private nbrDraftProductsSource = new BehaviorSubject(0);
  currentNbrDraftProducts = this.nbrDraftProductsSource.asObservable();

  private nbrDeletedProductsSource = new BehaviorSubject(0);
  currentNbrDeletedProducts = this.nbrDeletedProductsSource.asObservable();

  private nbrPendingProductsSource = new BehaviorSubject(0);
  currentNbrPendingProducts = this.nbrPendingProductsSource.asObservable();

  private nbrDeactivatedProductsSource = new BehaviorSubject(0);
  currentNbrDeactivatedProducts = this.nbrDeactivatedProductsSource.asObservable();

  private nbractivatedProductsSource = new BehaviorSubject(0);
  currentNbractivatedProducts = this.nbractivatedProductsSource.asObservable();
  //Trackin

  private nbrAllOrdersSource = new BehaviorSubject(0);
  currentNbrAllOrder = this.nbrAllOrdersSource.asObservable();

  private nbrProcessOrderSource = new BehaviorSubject(0);
  currentNbrProcessOrder = this.nbrProcessOrderSource.asObservable();

  private nbrTransitOrderSource = new BehaviorSubject(0);
  currentNbrTransitOrder = this.nbrTransitOrderSource.asObservable();

  private nbrDeliveredOrderSource = new BehaviorSubject(0);
  currentNbrDeliveredOrder = this.nbrDeliveredOrderSource.asObservable();

  private nbrReturningOrderSource = new BehaviorSubject(0);
  currentNbrReturningOrder = this.nbrReturningOrderSource.asObservable();

  private nbrReturnedOrderSource = new BehaviorSubject(0);
  currentNbrReturnedOrder = this.nbrReturnedOrderSource.asObservable();

  private nbrExceptionOrderSource = new BehaviorSubject(0);
  currentNbrExceptionOrder = this.nbrExceptionOrderSource.asObservable();

  private nbrNotFoundOrderSource = new BehaviorSubject(0);
  currentNbrNotFoundOrder = this.nbrNotFoundOrderSource.asObservable();

  private nbrPickUpOrderSource = new BehaviorSubject(0);
  currentNbrPickUpOrder = this.nbrPickUpOrderSource.asObservable();

  //end Tracking

  private subject = new Subject<any>();
  @Output() fire: EventEmitter<any> = new EventEmitter();

  constructor() {
    console.log('shared service started');
  }

  updateNbrOpenOrders(nbr: number) {
    this.nbrOpenOrdersSource.next(nbr);
  }
  updateNbrExceptionOrders(nbr: number) {
    this.nbrExceptionOrdersSource.next(nbr);
  }
  updateNbrPendingOrders(nbr: number) {
    this.nbrPendingOrdersSource.next(nbr);
  }
  updateNbrProcessingOrders(nbr: number) {
    this.nbrProcessingOrdersSource.next(nbr);
  }
  updateNbrDeletedOrders(nbr: number) {
    this.nbrDeletedOrdersSource.next(nbr);
  }
  updateNbrFrozenOrders(nbr: number) {
    this.nbrFrozenOrdersSource.next(nbr);
  }
  updateNbrShippedOrders(nbr: number) {
    this.nbrShippedOrdersSource.next(nbr);
  }
  updateNbrAbnormalOrders(nbr: number) {
    this.nbrAbnormalOrdersSource.next(nbr);
  }
  updateNbrFilteredOrders(nbr: number) {
    this.nbrFilteredOrdersSource.next(nbr);
  }

  //update Nbr ASN by Status

  updateNbrOpenAsns(nbr: number) {
    this.nbrOpenAsnsSource.next(nbr);
  }
  updateNbrExceptionAsns(nbr: number) {
    this.nbrExceptionAsnsSource.next(nbr);
  }
  updateNbrCanceledAsns(nbr: number) {
    this.nbrCanceledAsnsSource.next(nbr);
  }
  updateNbrPendingAsns(nbr: number) {
    this.nbrPendingAsnsSource.next(nbr);
  }
  updateNbrProcessingAsns(nbr: number) {
    this.nbrProcessingAsnsSource.next(nbr);
  }

  updateNbrAllProducts(nbr: number) {
    this.nbrAllProductsSource.next(nbr);
  }

  //update Nbr Products by Status
  updateNbrDraftProducts(nbr: number) {
    this.nbrDraftProductsSource.next(nbr);
  }
  updateNbrDeletedProducts(nbr: number) {
    this.nbrDeletedProductsSource.next(nbr);
  }
  updateNbrPendingProducts(nbr: number) {
    this.nbrPendingProductsSource.next(nbr);
  }
  updateNbrDeactivatedProducts(nbr: number) {
    this.nbrDeactivatedProductsSource.next(nbr);
  }
  updateNbractivatedProducts(nbr: number) {
    this.nbractivatedProductsSource.next(nbr);
  }
  //Tracking

  updateNbrAllOrder(nbr: number) {
    this.nbrAllOrdersSource.next(nbr);
  }
  updateNbrTransitOrder(nbr: number) {
    this.nbrTransitOrderSource.next(nbr);
  }
  updateNbrProcessOrder(nbr: number) {
    this.nbrProcessOrderSource.next(nbr);
  }
  updateNbrDeliveredOrder(nbr: number) {
    this.nbrDeliveredOrderSource.next(nbr);
  }
  updateNbrExceptionOrder(nbr: number) {
    this.nbrExceptionOrderSource.next(nbr);
  }

  updateNbrNotFoundOrder(nbr: number) {
    this.nbrNotFoundOrderSource.next(nbr);
  }
  updateNbrPickUpOrder(nbr: number) {
    this.nbrPickUpOrderSource.next(nbr);
  }
  updateNbrReturningOrder(nbr: number) {
    this.nbrReturningOrderSource.next(nbr);
  }
  updateNbrReturnedOrder(nbr: number) {
    this.nbrReturnedOrderSource.next(nbr);
  }
  //end Tracking

  change(data) {
    console.log('change started');
    this.fire.emit(data);
  }

  getEmittedValue() {
    return this.fire;
  }

  setLanguage(lang: string) {
    this.subject.next(lang);
  }

  getLanguage(): Observable<any> {
    console.log('GG');
    return this.subject.asObservable();
  }
}
